let host = "https://api.smalltea.xiaoxxx.cn"
// let host = "http://test.api.smalltea.xiaoxxx.cn"
export default host